import { createElement, forwardRef } from "react";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import listPlugin from "@fullcalendar/list";
import itLocale from "@fullcalendar/core/locales/it";
import enLocale from "@fullcalendar/core/locales/en-gb";
import esLocale from "@fullcalendar/core/locales/es";
import deLocale from "@fullcalendar/core/locales/de";
import sqLocale from "@fullcalendar/core/locales/sq";
import roLocale from "@fullcalendar/core/locales/ro";
import { fcLocaleCode } from "@/i18n";

const LOCALES = [itLocale, enLocale, esLocale, deLocale, sqLocale, roLocale];
const HM = { hour: "2-digit", minute: "2-digit", hour12: false };

const renderEvent = (arg) => {
  const p = arg.event.extendedProps;
  if (arg.view.type.startsWith("list")) {
    return (
      <div className="flex flex-col">
        <span className="font-medium">{arg.event.title}</span>
        {p.sub && <span className="text-xs opacity-70">{p.sub}</span>}
      </div>
    );
  }
  return (
    <div className="px-1 py-0.5 overflow-hidden leading-tight text-[11px] h-full">
      {arg.timeText && <span className="font-semibold mr-1 opacity-90">{arg.timeText}</span>}
      <span className="font-semibold">{arg.event.title}</span>
      {p.sub && !arg.event.allDay && <div className="opacity-85 truncate">{p.sub}</div>}
    </div>
  );
};

export const CalendarView = forwardRef(function CalendarView({ events, editable, initialView, onSelect, onEventClick, onMove, onDatesSet }, ref) {
  // createElement: evita che attributi extra aggiunti in sviluppo finiscano tra le opzioni del calendario
  return createElement(FullCalendar, {
    ref, initialView, events, editable,
    plugins: [dayGridPlugin, timeGridPlugin, interactionPlugin, listPlugin],
    headerToolbar: false, locales: LOCALES, locale: fcLocaleCode(), firstDay: 1,
    height: "100%", expandRows: true, slotMinTime: "06:00:00", slotMaxTime: "22:00:00", scrollTime: "07:30:00",
    slotDuration: "00:30:00", snapDuration: "00:15:00", nowIndicator: true, dayMaxEvents: 3, eventDisplay: "block",
    eventDurationEditable: editable, selectable: editable, selectMirror: true, longPressDelay: 350,
    eventAllow: (drop) => !drop.allDay,
    select: onSelect, eventClick: onEventClick, eventDrop: onMove, eventResize: onMove, datesSet: onDatesSet,
    eventTimeFormat: HM, slotLabelFormat: HM,
    businessHours: { daysOfWeek: [1, 2, 3, 4, 5, 6], startTime: "07:00", endTime: "19:00" },
    eventContent: renderEvent,
    eventDidMount: (info) => {
      info.el.setAttribute("data-testid", `agenda-event-${info.event.id}`);
      const stripe = info.event.extendedProps.stripe;
      if (stripe && !info.view.type.startsWith("list")) info.el.style.boxShadow = `inset 4px 0 0 ${stripe}`;
    },
  });
});

export default CalendarView;
